const ActionTypes = {
  OPEN:       'notifications/open',
  CLOSE:      'notifications/close'
};

export default ActionTypes;
